import { render, staticRenderFns } from "./CBC_DetailEachID_V2.vue?vue&type=template&id=6d1c2b7f&scoped=true"
import script from "./CBC_DetailEachID_V2.vue?vue&type=script&lang=js"
export * from "./CBC_DetailEachID_V2.vue?vue&type=script&lang=js"
import style0 from "./CBC_DetailEachID_V2.vue?vue&type=style&index=0&id=6d1c2b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c2b7f",
  null
  
)

export default component.exports